import { FarcasterIcon } from '#app/components/icons'

export default {
	name: 'Farcast',
	slug: 'cast',
	description: 'Import a Farcaster Post using its URL',
	version: '0.0.1',
	icon: <FarcasterIcon />,
	fields: [
		{
			name: 'URL',
			slug: 'url',
			required: true,
			type: 'text',
			placeholder: 'Enter a Cast URL',
		},
		{
			name: 'Description',
			slug: 'description',
			required: false,
			type: 'text',
			placeholder: 'Enter a Comment',
		},
		{
			name: 'Image Web2 URL',
			slug: 'web2URL',
			required: true,
			hidden: true,
			type: 'text',
			placeholder: 'Cached Web2 URL of the cast screenshot',
		},
		{
			name: 'IPFS CID',
			slug: 'ipfsCID',
			required: false,
			type: 'text',
			placeholder: 'Enter an IPFS URL',
			hidden: true,
		},
		{
			name: 'ArweaveTXID',
			slug: 'arweaveTxId',
			required: false,
			type: 'text',
			placeholder: 'Enter an Arweave URL',
			hidden: true,
		},
		{
			name: 'Timestamp',
			slug: 'timestamp',
			required: false,
			type: 'text',
			placeholder: 'Timestamp of Cast',
			hidden: true,
		},
	],
	info: 'https://atomicform.faq',
}
